import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:survey-configuration',
    appAlias: space.RESOURCE.payload.alias,
    description:
      'Manage survey configuration for the current scenario in Space Full',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Survey Configuration',
    page: { id: prebuilt.Page.Id.SpaceSurveyConfiguration },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
